import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { getApp } from "../app";
import { Message } from "../../../../shared/models/message";

@Component({
    selector: "app-message-item",
    templateUrl: "./message-item.component.html",
    styleUrls: ["./message-item.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessageItemComponent {
  app = getApp((app) => {
    this.app = app;
  });

  @Input() showMessages = true;
  @Input() message = {} as Message;
  @Input() type = "";

  togglePost() {
    this.showMessages = !this.showMessages;
  }

  hasEditedCredits() {
    return (
      this.message != null &&
      this.message.update_time != null &&
      this.message.create_time !== this.message.update_time
    );
  }
}
